/**
 * Simple comparison to detect data changes using JSON serialization.
 * Returns true if the data has changed, false otherwise.
 */
export const hasDataChanged = (oldData: unknown, newData: unknown): boolean => {
  try {
    return JSON.stringify(oldData) !== JSON.stringify(newData);
  } catch {
    return true; // Assume changed if comparison fails
  }
};
